/* tslint:disable */
/* eslint-disable */
/**
 * Probonio full API Docs
 * If you stumbled upon this page and want to integrate Probonio into your business software [click here!](/api/external)    If you\'re looking for more information about Probonio [head over here](https://probonio.de)    **This documentation describes all Endpoints of the Probonio API. It\'s created for experienced Probonio Developers only!**   <a href=\"http://localhost:4100/mock-idp/realms/probonio/protocol/openid-connect/logout\" target=\"_blank\"><button>     <h4>Click here to trigger a full logout from Keycloak.</h4> </button></a><br /> 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface UpdateMeDTO
 */
export interface UpdateMeDTO {
    /**
     * 
     * @type {string}
     * @memberof UpdateMeDTO
     */
    'salutation'?: UpdateMeDTOSalutationEnum;
    /**
     * 
     * @type {string}
     * @memberof UpdateMeDTO
     */
    'title'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMeDTO
     */
    'firstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMeDTO
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMeDTO
     */
    'phone'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateMeDTO
     */
    'locale'?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateMeDTO
     */
    'localeManager'?: string;
    /**
     * Street address of user home
     * @type {string}
     * @memberof UpdateMeDTO
     */
    'homeAddressStreet'?: string | null;
    /**
     * Optional second field of user home address
     * @type {string}
     * @memberof UpdateMeDTO
     */
    'homeAddressStreetLine2'?: string | null;
    /**
     * Postal code of user home address
     * @type {string}
     * @memberof UpdateMeDTO
     */
    'homeAddressPostalCode'?: string | null;
    /**
     * City of user home address
     * @type {string}
     * @memberof UpdateMeDTO
     */
    'homeAddressCity'?: string | null;
    /**
     * Region of user home address
     * @type {string}
     * @memberof UpdateMeDTO
     */
    'homeAddressRegion'?: string | null;
    /**
     * The country of the user\'s home address in ISO31661Alpha2 format
     * @type {string}
     * @memberof UpdateMeDTO
     */
    'homeAddressCountry'?: string | null;
    /**
     * Employee personnel number
     * @type {string}
     * @memberof UpdateMeDTO
     */
    'personnelNumber'?: string | null;
    /**
     * Cost center assignment
     * @type {string}
     * @memberof UpdateMeDTO
     */
    'costCenter'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateMeDTO
     */
    'showWelcomeMessage'?: boolean;
}

export const UpdateMeDTOSalutationEnum = {
    Mr: 'MR',
    Ms: 'MS',
    Divers: 'DIVERS'
} as const;

export type UpdateMeDTOSalutationEnum = typeof UpdateMeDTOSalutationEnum[keyof typeof UpdateMeDTOSalutationEnum];


